import { render, staticRenderFns } from "./CreateDueDiligenceReport.vue?vue&type=template&id=365cdb06&scoped=true"
import script from "./CreateDueDiligenceReport.vue?vue&type=script&lang=js"
export * from "./CreateDueDiligenceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365cdb06",
  null
  
)

export default component.exports